import React from 'react'
import ToggleButtonContainer from 'components/OfferPage/ToggleButtonContainer'

export interface CharterDurationToggleOption {
  label: string
  value: number
  displayPrice?: number
  buttonStartIcon?: React.ReactNode
  disabled?: boolean
}

interface Props {
  options: ReadonlyArray<CharterDurationToggleOption>
  selectedValue: number
  onChange: (value: number) => void
  unavailableMessage?: string
  isMemberPrice?: boolean
  pricesLoading?: boolean
}

function CharterDurationToggleControl(props: Props) {
  const {
    options,
    selectedValue,
    onChange,
    unavailableMessage,
    isMemberPrice,
    pricesLoading,
  } = props

  if (options.length < 2) {
    return null
  }

  const [optionA, optionB] = options

  const handleOptionChange = (value: string) => {
    const parsedValue = parseInt(value, 10)
    if (Number.isNaN(parsedValue)) {
      return
    }
    onChange(parsedValue)
  }

  return (
    <ToggleButtonContainer
      optionA={{
        label: optionA.label,
        value: String(optionA.value),
        displayPrice: optionA.displayPrice,
        buttonStartIcon: optionA.buttonStartIcon,
      }}
      optionB={{
        label: optionB.label,
        value: String(optionB.value),
        displayPrice: optionB.displayPrice,
        buttonStartIcon: optionB.buttonStartIcon,
      }}
      selectedValue={String(selectedValue)}
      disableOptionB={optionB.disabled}
      unavailableMessage={unavailableMessage}
      onOptionChange={handleOptionChange}
      isMemberPrice={isMemberPrice}
      pricesLoading={pricesLoading}
    />
  )
}

export default CharterDurationToggleControl
